<template>
  <div class="tabs tw-bg-[#ffffff] tw-w-full">
    <div
      class="tw-flex tw-flex-wrap tw-justify-between tw-border-b-[#EFF0F1] tw-border-solid tw-border-[0] tw-border-b-[1px] tw-pr-[20px]"
    >
      <div class="tab-header tw-flex tw-flex-wrap">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          :class="[
            {
              selectedTab: selectedTab === index,
              unselectedTab: selectedTab !== index,
            },
            `tab tw-px-[20px] tw-pt-[20px] tw-pb-[17px] tw-cursor-pointer tw-text-center ${itemClass}`,
          ]"
          @click="selectTab(tab, index)"
        >
          <span>{{ tab.title }}</span>
        </div>
      </div>
      <slot name="rightHeader">
        <div
          class="tw-flex tw-flex-row tw-gap-[10px] tw-items-center tw-justify-center"
        >
          <BarChartIcon />
          <div class="title tw-flex tw-flex-row">
            {{
              getComponentUiText(
                "app-assess-recommendations-action-table-label-score-1",
              )
            }}
            <div class="value">{{ score }}</div>
            <div class="tw-px-2">
              <svg
                width="4"
                height="11"
                viewBox="0 0 4 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="3.03418"
                  y="0.541016"
                  width="1"
                  height="10"
                  rx="0.5"
                  transform="rotate(15 3.03418 0.541016)"
                  fill="#DBDBDB"
                />
              </svg>
            </div>
            {{
              getComponentUiText(
                "app-assess-recommendations-action-table-label-risk-1",
              )
            }}
            <div class="value">{{ risk }}</div>
          </div>
        </div>
      </slot>
    </div>
  </div>
</template>
<script setup lang="ts">
import { ref, watch } from "vue";
import { ISwitchTabs } from "@/interfaces/assessments/ISwitchTabs";
import BarChartIcon from "@/components/svgs/barChartIcon.vue";
import { getComponentUiText } from "@/utils/utilities";
// eslint-disable-next-line no-unused-vars
const props = defineProps({
  tabs: {
    type: Array as () => ISwitchTabs[],
    required: true,
  },
  defaultTab: {
    type: Number,
    default: 0,
    required: false,
  },
  idSelectedTab: {
    type: String,
    default: null,
    required: false,
  },
  score: {
    type: Number,
    default: 1,
    required: false,
  },
  risk: {
    type: Number,
    default: 1,
    required: false,
  },
  itemClass: {
    type: String,
    default: "",
    required: false,
  },
});
const emit = defineEmits(["update:tab"]);

const selectedTab = ref(props.defaultTab);

watch(
  () => props.idSelectedTab,
  (value) => {
    props.tabs.forEach((tab, index) => {
      if (tab.id === value) {
        selectedTab.value = index;
      }
    });
  },
);

const selectTab = (tab: ISwitchTabs, index) => {
  emit("update:tab", tab.id);
  selectedTab.value = index;
};
</script>

<style scoped lang="scss">
.tab-header {
  gap: 6px 0px;
  .tab {
    color: var(--UI-light-grey, #b7b7b7);
    font-family: Poppins;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
    border-bottom: 3px solid transparent;
    &.selectedTab {
      border-bottom-color: #387dff;
      color: var(--Brand-Navy, #211f58);
      font-family: Poppins;
      font-size: 14px;
      font-style: normal;
      font-weight: 500;
      line-height: normal;
    }
  }
}
.tabs {
  margin: 0 auto;
}
.title {
  color: var(--Brand-Navy, #211f58);
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 400;
  line-height: 130%; /* 14.3px */
}
.value {
  color: var(--Brand-Navy, #211f58);
  font-family: Poppins;
  font-size: 11px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  margin-left: 4px;
}
</style>
